module.exports = __webpack_public_path__ + "img/retro_pc.b52155a6.gif";